// =============================================================================
// HUB COMMERCIAL - Dashboard (CC-25b — version "grille de widgets")
// =============================================================================
// Les 5 blocs historiques (KPIs, distribution funnel cible, entonnoir global,
// taux par visiteur, tableau détaillé) ont été extraits en widgets dans
// frontend/src/widgets/commercial/, catalogués côté serveur
// (backend/dashboard/catalog.py) et résolus via la cascade dashboard_layouts.
//
// L'ancien rendu monolithique reste accessible dans l'historique git.
// =============================================================================
import DashboardGrid from "../../components/dashboard/DashboardGrid";

export default function DashboardPipelineCommercial({ tenantId }) {
  return (
    <DashboardGrid hub="commercial" title="Pipeline Commercial" />
  );
}
